import { matchPath, useLocation } from 'react-router-dom';

export const useClientCodeFromUrl = (): string | undefined => {
  const { pathname } = useLocation();
  return matchPath('/client/:code', pathname)?.params.code?.toUpperCase();
};
